'use client';

import { useAppConfiguration } from '@/features/app-config';
import { useTranslation } from '@/features/i18n';
import { Link } from '@/ui/Link';
import { BookmarkIcon } from '@heroicons/react/24/outline';
import { LockClosedIcon } from '@heroicons/react/24/solid';
import { useSubprofiles } from '@vimond/features/subprofiles';

type Props = {
  active?: boolean;
};

export const WatchListButton = ({ active }: Props) => {
  const { t } = useTranslation();

  const { subprofileToken } = useSubprofiles();
  const { authenticationEnabled } = useAppConfiguration();

  if (!authenticationEnabled) return <></>;

  // if not logged in show alternative button
  if (!subprofileToken) {
    return (
      <Link
        href="/auth/signin"
        className="text-white opacity-70 hover:opacity-100"
      >
        <div
          className="group relative cursor-pointer"
          title={t(
            'you-need-to-login-before-you-can-add-content-to-your-watchlist',
          )}
        >
          <BookmarkIcon className=" h-6 w-6" />
          <LockClosedIcon className="text-text-highlight absolute bottom-0 right-0 h-4 w-4" />
        </div>
      </Link>
    );
  }

  return (
    <Link
      href="/browse/watchlist"
      className={
        active
          ? 'text-text-highlight'
          : 'text-white opacity-70 hover:opacity-100'
      }
    >
      <BookmarkIcon className="h-6 w-6" />
    </Link>
  );
};
